import { breakpoints, LinkButton, vars } from '@etg/wings';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import SummaryPriceRow from './SummaryPriceRow';
import SummaryActionsCell from './SummaryActionsCell';
import { seatingPreferenceValues } from '../../constants/seatingPreferenceValues';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const rowStyles = css`
  border-top: 1px solid ${vars.colors.divider};
  display: flex;
  flex-direction: column;
  font-size: 0.875rem;
  padding: 0.5rem 0;
  position: relative;
  width: 100%;

  & > * {
    vertical-align: middle;
  }

  @media (min-width: ${breakpoints._768}) {
    border-top: none;
    display: table-row;
    flex-direction: unset;
    padding: 0;
  }
`;
const unavailableRowStyles = css`
  border-top: 1px solid ${vars.colors.inputs.border};
  display: flex;
  font-size: 0.875rem;
  padding: 0.5rem 0;

  & > * {
    vertical-align: middle;
  }

  @media (min-width: ${breakpoints._768}) {
    border-top: none;
    display: table-row;
    padding: 0;
  }
`;
const cellStyles = css`
  display: contents;
  font-size: 0.75rem;
  margin-inline-start: 2.25rem;

  & div {
    width: 50%;
  }

  @media (min-width: ${breakpoints._768}) {
    align-items: baseline;
    display: table-cell;
    font-size: 0.875rem;
    margin-inline-start: 0;
  }
`;
const unavailableCellStyles = css`
  color: ${vars.colors.decoration.neutral};
  flex: 1;
  font-size: 0.75rem;
  padding: 0.875rem;
  text-align: center;

  @media (min-width: ${breakpoints._768}) {
    font-size: 0.875rem;
  }

  @media (min-width: ${breakpoints._970}) {
    flex: initial;
    padding: 0.625rem;
  }
`;
const SummaryUnavailableRow = ({
  onRemoveOption,
  onToggleOptionSelect,
  boundIndex,
  isSeatPreference,
  segmentIndex,
  selected
}) => {
  var _selected$;
  const {
    t
  } = useTranslation();
  const [selectedOption] = selected || [];
  const seatPreference = (_selected$ = selected[0]) === null || _selected$ === void 0 ? void 0 : _selected$.seatPreference;
  const getTextForType = optionType => {
    switch (optionType) {
      case seatingPreferenceValues.AISLE:
        return t('Product.SeatMap.Segment.Unavailable.SeatingCombo.Values.Aisle.Content');
      case seatingPreferenceValues.WINDOW:
        return t('Product.SeatMap.Segment.Unavailable.SeatingCombo.Values.Window.Content');
      case seatingPreferenceValues.BESIDE:
        return t('Product.SeatMap.Segment.Unavailable.SeatingCombo.Values.Beside.Content');
      case seatingPreferenceValues.RANDOM:
        return t('Product.SeatMap.Segment.Unavailable.SeatingCombo.Values.AnySeat.Content');
      default:
        return t('Product.SeatMap.Summary.Segment.Unavailable');
    }
  };
  if (!isSeatPreference) {
    return /*#__PURE__*/_jsx("tr", {
      className: unavailableRowStyles,
      children: /*#__PURE__*/_jsx("td", {
        className: unavailableCellStyles,
        colSpan: 5,
        children: t('Product.SeatMap.Summary.Segment.Unavailable')
      })
    });
  }
  if (isSeatPreference && seatPreference === seatingPreferenceValues.RANDOM) {
    return /*#__PURE__*/_jsx("tr", {
      className: unavailableRowStyles,
      children: /*#__PURE__*/_jsxs("td", {
        className: unavailableCellStyles,
        colSpan: 5,
        children: [t('Product.SeatMap.Segment.Unavailable.SeatingCombo.Values.AnySeat.Content'), ` `, /*#__PURE__*/_jsx(LinkButton, {
          onClick: onToggleOptionSelect,
          children: t('Product.SeatMap.Summary.Segment.Unavailable.Cta.Label')
        })]
      })
    });
  }
  if (isSeatPreference && selectedOption && selectedOption.seatPreference) {
    const totalPrice = selected.some(traveler => traveler.price != null) ? selected.reduce((total, traveler) => {
      var _traveler$price;
      return total + ((_traveler$price = traveler.price) !== null && _traveler$price !== void 0 ? _traveler$price : 0);
    }, 0) : undefined;
    const totalMarkup = selected.some(traveler => traveler.markup != null) ? selected.reduce((total, traveler) => {
      var _traveler$markup;
      return total + ((_traveler$markup = traveler.markup) !== null && _traveler$markup !== void 0 ? _traveler$markup : 0);
    }, 0) : undefined;
    return /*#__PURE__*/_jsxs("tr", {
      className: rowStyles,
      children: [/*#__PURE__*/_jsx("td", {
        className: cellStyles,
        colSpan: 3,
        children: /*#__PURE__*/_jsx("div", {
          children: getTextForType(selectedOption.seatPreference)
        })
      }), /*#__PURE__*/_jsx(SummaryPriceRow, {
        markup: totalMarkup,
        tooltipId: `row_${boundIndex}_${segmentIndex}_0`,
        seatPrice: totalPrice
      }), /*#__PURE__*/_jsx(SummaryActionsCell, {
        boundIndex: boundIndex,
        onRemoveSeat: onRemoveOption,
        onToggleSeatSelect: onToggleOptionSelect,
        segmentIndex: segmentIndex,
        selectedSeat: selectedOption,
        travelerIndex: 0
      })]
    });
  }
  return /*#__PURE__*/_jsx("tr", {
    className: unavailableRowStyles,
    children: /*#__PURE__*/_jsxs("td", {
      className: unavailableCellStyles,
      colSpan: 5,
      children: [t('Product.SeatMap.Summary.Segment.Unavailable'), ` `, /*#__PURE__*/_jsx(LinkButton, {
        onClick: onToggleOptionSelect,
        children: t('Product.SeatMap.Segment.Unavailable.SeatingCombo.Values.AnySeat.Content')
      })]
    })
  });
};
export default SummaryUnavailableRow;
//# sourceMappingURL=SummaryUnavailableRow.js.map